import { render } from "./BreadcrumbLabel.vue?vue&type=template&id=44a67f10"
import script from "./BreadcrumbLabel.vue?vue&type=script&lang=js"
export * from "./BreadcrumbLabel.vue?vue&type=script&lang=js"

import "./BreadcrumbLabel.vue?vue&type=style&index=0&id=44a67f10&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__